<template>
    <div class="wrapper -noticias">
        <section class="encabezado -noticias column-center">
            <h1>Noticias</h1>
        </section>

        <section class="breadcrumb">
            <nav class="container row-start">
                <router-link :to="{ name: 'home' }">Hiper Usera</router-link>
                <router-link :to="{ name: 'noticias' }">Noticias</router-link>
            </nav>
        </section>

        <section class="intro-noticias">
            <div class="container">
                <h2 class="title -rojo">Descubre nuestras noticias</h2>
            </div>


            <div class="buscador container row-center">
                <div class="column-start">
                    <label for="search">Buscador</label>
                    <input name="search" type="text" v-model="textFilter">
                </div>
                <div class="column-start">
                    <label for="category">Categoría</label>
                    <select name="category" v-model="categoryFilter">
                        <option :value="null">
                            {{ categoryFilter ? "Eliminar Categoría" : "Seleccionar Categoría" }}
                        </option>
                        <option :key="key" :value="categoria" v-for="(categoria, key) in store.categories">
                            {{ categoria.name }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="container listado-noticias row-center" v-if="noticias">
                <noticia v-for="(noticia, key) in noticias" :data="noticia" :key="key"></noticia>
            </div>
            <paginador :perPage="9" :max="store.entries.maxItems" :current="store.entries.viewPage" v-model="page" />
        </section>

    </div>
</template>
<script>

import noticia from '@/components/noticia';
import paginador from '@/components/paginador';

import { entriesStore } from '@/store/entries'

export default {
    name: 'noticias-view',
    components: {
        'noticia': noticia,
        'paginador': paginador
    },
    data() {
        const eStore = entriesStore();
        return {
            textFilter: eStore.entries.lastFilters.text,
            categoryFilter: eStore.entries.lastFilters.category,
            timer: null,
            page: eStore.entries.viewPage,
            store: eStore,
        }
    },
    computed: {
        noticias() {
            return this.store.getEntries(this.page);
        },
    },
    methods: {
        loadEntries() {
            this.store.loadEntries({
                page: this.page,
                categoryFilter: this.categoryFilter,
                textFilter: this.textFilter
            });
        }
    },
    mounted() {
        if(this.$route.query.category && this.store.categories[this.$route.query.category]){
           this.categoryFilter = this.store.categories[this.$route.query.category];
        }
        this.loadEntries();
        this.store.loadCategories();
    },
    watch: {
        "page"() {
            this.loadEntries();
        },
        "textFilter"() {
            let t = this;
            clearTimeout(this.timer);
            this.timer = setTimeout(function () {
                t.page = 1;
                t.loadEntries();
            }, 512);
        },
        "categoryFilter"() {
            this.page = 1;
            this.loadEntries();
        }
    }
}
</script>